import style from '@src/components/Line/Line.module.scss'

export const Line = () => (
  <div className={style.line} />
)
